import React, {useCallback, useEffect, useMemo, useState} from "react";
import Breadcrumbs from "./../../../ui/Breadcrumbs";
import DeleteConfirmationModal from "../../../ui/DeleteConfirmationModal";
import AddFacilityModal from "../../components/AddFacilityModal";
import QueryTable from "../../../ui/QueryTable";
import AddButton from "../../../ui/AddButton";
import FacilityInfoDrawer from "../../components/FacilityInfoDrawer";
import {makeStyles} from "@material-ui/core/styles";
import useBuildings from "./useBuildings";
import useQuery from "../../../ui/QueryTable/useQuery";

const items = [
  {
    label: "Управление ООП",
    link: "#"
  },
  {
    label: "Ресурсы",
    link: "/work/app/manage/resources"
  },
  {
    label: "Материально-технические ресурсы",
    link: "/work/app/manage/resources/mattech"
  },
  {
    label: "Мои адреса",
    link: "#"
  }
];


const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "row",
    "& #gridContainer": {
      height: "calc(100vh - 200px)"
    }
  },
});

const FacilitiesList = () => {
  const query = useQuery(16);
  const [focusedFacility, setFocusedFacility] = useState(-1);
  const [selection, setSelection] = useState([]);
  const [addFacilityOpen, setAddFacilityOpen] = useState(false);
  const [deleteFacilityOpen, setDeleteFacilityOpen] = useState(false);
  const {root} = useStyles();

  const {
    isCreatingFacility,
    isDeletingFacilities,
    deleteFacilities,
    createFacility,
    data
  } = useBuildings();

  const actionsDisabled = isCreatingFacility || isDeletingFacilities;

  const createFacilityChain = useCallback((form) => {
    return createFacility(form)
      .then(() => {
        setAddFacilityOpen(false);
        query.refresh();
      }, () => {
        setAddFacilityOpen(false);
        query.refresh();
      })
  }, [setAddFacilityOpen, createFacility, query]);

  const deleteFacilitiesChain = useCallback(() => {
    return deleteFacilities(selection)
      .then(() => {
        setDeleteFacilityOpen(false);
        query.refresh();
      }, () => {
        setDeleteFacilityOpen(false);
        query.refresh();
      })
  }, [setDeleteFacilityOpen, deleteFacilities, selection, query]);

  const TableRowClick = useCallback((e) => {
    const focusedFacility = e ? e.key : -1;
    setFocusedFacility(focusedFacility);
  }, [setFocusedFacility]);

  const TableSelectionChanged = useCallback(e => {
    setSelection(e.selectedRowKeys || []);
  }, [setSelection]);

  const showDeleteModal = useCallback(() => {
    setDeleteFacilityOpen(!deleteFacilityOpen);
  }, [deleteFacilityOpen]);

  const showAddModal = useCallback(() => {
    setAddFacilityOpen(!addFacilityOpen)
  }, [addFacilityOpen]);

  const secondaryActions = useMemo(() => {
    return [
      {
        label: "Удалить выбранные",
        onClick: showDeleteModal,
        disabled: actionsDisabled || (!selection || selection.length === 0)
      },
    ]
  }, [showDeleteModal, selection]);

  useEffect(() => {
    query.load();
  }, []);

  return (
    <div>
      <DeleteConfirmationModal
        modalText="Удалить выбранные адреса?"
        open={deleteFacilityOpen}
        onConfirm={deleteFacilitiesChain}
        handleClose={showDeleteModal}
      />
      <AddFacilityModal
        open={addFacilityOpen}
        handleClose={showAddModal}
        createFacility={createFacilityChain}
        isCreatingFacility={isCreatingFacility}
        createdFacility={data.createdFacility}
      />
      <Breadcrumbs items={items} />
      <div className={root}>
        <QueryTable
          focusedId={focusedFacility}
          onSelectionChanged={TableSelectionChanged}
          onRowClick={TableRowClick}
          primaryActions={<AddButton onClick={showAddModal}/>}
          secondaryActions={secondaryActions}
          {...query} />
        <FacilityInfoDrawer
          handleDrawerClose={() => setFocusedFacility(-1)}
          facilityId={focusedFacility}
          open={focusedFacility !== -1}
        />
      </div>
    </div>
  );
};

/*const mapStateToProps = state => ({
  facilities: state.facilities.facilities
});

const mapDispatchToProps = dispatch => ({
  getFacilities: () => {
    dispatch(getFacilities());
  }
});*/

export default FacilitiesList;
